var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var authCurrentUserActions = require('../../../modules/auth/actions/auth-current-user');
var profileActions = require('../../../modules/profile/actions/profile');
var headerActions = require( '../../../modules/meta/actions/globalNav-click');
var footerActions = require( '../../../modules/meta/actions/footer-click');
var commonActions = require( '../../../modules/common/actions/common');
var authLoginActions = require('../../../modules/auth/actions/auth-login');
var loginClickActions = require( '../../../modules/meta/actions/login-click');
var authRegisterActions = require('../../../modules/auth/actions/auth-register');
var registerClickActions = require( '../../../modules/meta/actions/register-click');
var modalActions = require( '../../../modules/modals/actions/modal');
var clinicalTrialsMetaActions = require( '../../../modules/meta/actions/clinical-trials');
var authFacebookActions = require('../../../modules/auth/actions/auth-facebook');
var Main = require('../components/main.jsx');

  var mapStateToProps = function(state){
    return {
      ...state,
      generic_error: state.common.generic_error,
      generic_response_error: state.common.generic_response_error
    };
  }

  var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(Object.assign({}, authCurrentUserActions, profileActions, headerActions, footerActions, commonActions,
      authLoginActions, loginClickActions, authRegisterActions, registerClickActions, modalActions, clinicalTrialsMetaActions, authFacebookActions), dispatch);
  }

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/common/routes/main/containers/main.jsx